<script>
  import { checkPossibleAlignments } from "materialize-css"

  // This is just here to show how it could be used in any component
  // with zero dependency once the styles are in your stylesheet

  export let tooltip = false // prevent blank tooltips
  export let gua_code = 0
  export let index = 0

  import {
    checkYaoName,
    checkYaoType,
    checkMiddle,
    checkDangWei,
    checkCouple,
    checkBi,
    checkCC,
    checkMoving,
  } from "../etc/helpers.js"

  function genYaoTip(gua_code, i) {
    let finalText = ""
    let yaoName = checkYaoName(i)
    let yaoType = checkYaoType(gua_code, i)
    let dangWeiText = checkDangWei(gua_code, i)
    let middleText = checkMiddle(gua_code, i)
    let coupleText = checkCouple(gua_code, i)
    let biText = checkBi(gua_code, i)
    let ccText = checkCC(gua_code, i)

    finalText =
      yaoName +
      "; " +
      yaoType +
      "; " +
      dangWeiText +
      "; " +
      middleText +
      "; " +
      coupleText +
      "; " +
      biText +
      "; " +
      ccText

    return finalText
  }

  tooltip = genYaoTip(gua_code, index)
</script>

<div class="yao-n" data-tooltip={tooltip}>
  <slot />
</div>

<style>
  .yao-n:hover {
    cursor: pointer;
  }
</style>
